export default function Step3() {
    return (
        <svg width="53" height="52" viewBox="0 0 53 52" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M39.8069 8.66602H12.844C10.7167 8.66602 8.99219 10.3905 8.99219 12.5179V39.4808C8.99219 41.6081 10.7167 43.3327 12.844 43.3327H39.8069C41.9343 43.3327 43.6588 41.6081 43.6588 39.4808V12.5179C43.6588 10.3905 41.9343 8.66602 39.8069 8.66602Z"
                stroke="#7293F7"
                strokeWidth="2.5"
            />
            <path
                d="M26.3265 26.9626C28.9857 26.9626 31.1413 24.807 31.1413 22.1478C31.1413 19.4887 28.9857 17.333 26.3265 17.333C23.6674 17.333 21.5117 19.4887 21.5117 22.1478C21.5117 24.807 23.6674 26.9626 26.3265 26.9626Z"
                stroke="#7293F7"
                strokeWidth="2.5"
            />
            <path
                d="M34.9936 36.5915C34.9936 31.805 31.1134 27.9248 26.3269 27.9248C21.5404 27.9248 17.6602 31.805 17.6602 36.5915"
                stroke="#7293F7"
                strokeWidth="2.5"
                strokeLinecap="round"
            />
        </svg>
    );
}
